import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const txtesolutionConfig: TSPConfig = {
  key: 'txtesolution',
  name: 'TXTESolution',
  imageName: 'TXTESolution',
  category: TSPCategory.CREDENTIALS,
  helpText:
    'Please provide your TXTESolution username and password to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default txtesolutionConfig;
